import React, { Component } from 'react';
import {
  Text,
  View,
  FlatList,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  ScrollView,
} from '../../src/web/react-native';
import Icon from '../../src/components/Icon';
import Service from '../../Service/service';
import moment from 'moment';
import store from '../../store';
import { GetShiftLogsActionAsync } from '../../Action/ShiftLogAction';
import ShiftLogs from './ShiftLogs';
import { connect } from 'react-redux';

export class TakeOver extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentShiftStart: '',
      width: Dimensions.get('window').width,
    };
  }

  async componentDidMount() {
    Dimensions.addEventListener('change', () => {
      this.setState({
        width: Dimensions.get('window').width,
        height: Dimensions.get('window').height,
      });
    });
  }
  render() {
    return (
      <View style={{ flex: 1, width: this.state.width, backgroundColor: '#fff' }}>
        {
          <FlatList
            data={
              this.props.route.params && this.props.route.params.isTeamLog
                ? this.props.teamShiftLogs.filter((val) => val.status == 'TakenOver')
                : this.props.shiftLogs.filter((val) => val.status == 'TakenOver')
            }
            extraData={this.props}
            renderItem={({ item }) => {
              return (
                <Item
                  item={item}
                  currentShiftStart={this.props.preference.currentShiftStart}
                  currentShiftEnd={this.props.preference.currentShiftEnd}
                  previousShiftStart={this.props.preference.previousShiftStart}
                  previousShiftEnd={this.props.preference.previousShiftEnd}
                  navigation={this.props.navigation}
                  isTeamLog={this.props.route.params && this.props.route.params.isTeamLog}></Item>
              );
            }}
            keyExtractor={(item) => item.shiftSummaryID.toString()}
          />
        }
      </View>
    );
  }
}
function Item({
  item,
  navigation,
  currentShiftStart,
  currentShiftEnd,
  previousShiftStart,
  previousShiftEnd,
  isTeamLog,
}) {
  let width = Dimensions.get('window').width;
  let isPrev =
    moment(item.shiftStart).isSameOrAfter(previousShiftStart) &&
    moment(item.shiftEnd).isSameOrBefore(previousShiftEnd);
  let isCurrent =
    moment(item.shiftStart).isSameOrAfter(currentShiftStart) &&
    moment(item.shiftEnd).isSameOrBefore(currentShiftEnd);
  let description = '';
  let user = '';
  let displayDate = '';
  if (item.status == 'Submitted') {
    description = 'Submitted';
    user = item.submitUser;
    displayDate = moment(item.submitTime).format('MMM DD, YYYY h:mm a');
  } else if (item.status == 'TakenOver') {
    description = 'Taken Over';
    user = item.takeoverUser;
    displayDate = moment(item.takeoverTime).format('MMM DD, YYYY h:mm a');
  } else {
    description = 'Created';
    user = item.createUser;
    displayDate = moment(item.createTime).format('MMM DD, YYYY h:mm a');
  }

  return (
    <ShiftLogs
      item={item}
      isPrev={isPrev}
      isCurrent={isCurrent}
      description={description}
      user={user}
      displayDate={displayDate}
      width={width}
      navigation={navigation}
      isTeamLog={isTeamLog}></ShiftLogs>
  );
}

const mapStateToProps = (state) => ({
  shiftLogs: state.shiftLogs.shiftLogs,
  teamShiftLogs: state.shiftLogs.teamShiftLogs,
  preference: state.preference.preferences,
});

export default connect(mapStateToProps)(TakeOver);
